import {extendComponent} from "juis-components/ComponentUtils.js";
import BULMA from "./bulma_components/bulmaCssClasses.js";
import Container from "juis-components/Container.js";
import HTML from "./utils/HTML.js";
import {createIcon} from "./bulma_components/Icon.js";
import TextComponent from "./components/TextComponent.js";

export default extendComponent(Container, function () {
    this.getNode().addWrapper(HTML.SECTION, [BULMA.SECTION]);

    this.icon = createIcon("exclamation-triangle", BULMA.TYPOGRAPHY.HAS_TEXT_PRIMARY);
    this.icon.isLarge = true;

    this.text = new TextComponent("Not found", HTML.DIV, "title");
    this.setText = (text) => this.text.text = text;

}, [BULMA.HAS_TEXT_CENTERED]);
